import immutablePersistenceTransform from 'APP/Lib/Immutable'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { createBlacklistFilter } from 'redux-persist-transform-filter'
import { toCamelCase } from 'APP/Lib/Helpers'
import { isWeb } from 'APP/Helpers/checkPlatform'

export const securelyPersistedLoginEntries: string[] = [
  'accessToken',
  'refreshToken',
  'idToken',
  'secondaryAccessToken',
  'exchangeToken',
]
export const getSecureStorageKeys = (): string[] =>
  securelyPersistedLoginEntries.map((key) => ['login', key].join('.'))

const patientProfileBlacklistItems: string[] = [
  'date_of_birth',
  'email',
  'family_name',
  'given_name',
  'preferred_name',
  'healthcard_number',
  'phone_number',
  'postal_code',
  'street_number',
].flatMap((item) => [item, toCamelCase(item)])

// This prevents specific keys in various stores from being saved and rehydrated
const storeKeyBlackListFilter = [
  ...securelyPersistedLoginEntries.map((key) => ['login', key]),
  ['login', 'fetching'],
  ['login', 'isLoggingIn'],
  ['login', 'username'],
  ['login', 'password'],
  ['login', 'toggleMfaRequestRunning'],
  ['login', 'toggleMfaRequestFailed'],
  ['login', 'isLoggingOut'],
  ['login', 'customClaims.email'],
  ['login', 'customClaims.name'],
  ['login', 'hydrated'],
  ['family', 'requestRunning'],
  ...patientProfileBlacklistItems.map((key) => ['patient', `profile.${key}`]),
  ['patient', 'userInfo.email'],
  ['patient', 'userInfoFetchError'],
  ['patient', 'profileFetchRunning'],
  ['patient', 'requests'],
  ['patient', 'requestRunning'],
  ['patient', 'changeEmailRunning'],
  ['patient', 'changeEmailError'],
  ['patient', 'unchallengedInvitationSearchRunning'],
  ['patient', 'challengedInvitationSearchRunning'],
  ['patient', 'enrolWithEnrolmentCodesResult'],
  ['patient', 'challengedInvitationQueue'],
  ['patient', 'challengeInvitationRunning'],
  ['patient', 'challengeInvitationError'],
  ['patient', 'pillway'],
  ['family', 'members'],
  ['app', 'pushTokenRetryCount'],
  ['app', 'pushToken'],
  ['app', 'updateStatusDuration'],
  ['app', 'fullyInitialized'],
  ['app', 'navigationReady'],
  ['accountLinking', 'running'],
].map((e) => createBlacklistFilter(e[0], [e[1]], [e[1]]))

const REDUX_PERSIST = {
  active: true,
  storeConfig: {
    storage: AsyncStorage,
    blacklist: [
      'initialization',
      'brownfield',
      'preload',
      'appSession',
      'deeplink',
      'videoSession',
      'nativecallios',
      'nativecallandroid',
      'forms',
      'handoff',
      'history',
      'wellnessCenter',
      'habits',
      'activeMinutes',
      'wellBeingAssessment',
      'appointmentBooking',
      'providerBooking',
      'notifications',
      'places',
      'toast',
      'features',
      'memberTasks',
      ...(isWeb() ? ['content'] : []),
    ] as string[],
    transforms: [immutablePersistenceTransform, ...storeKeyBlackListFilter],
  },
}

export default REDUX_PERSIST
